'use client'

import React from 'react'
import {css} from '@emotion/react'
import {Paper} from '@mui/material'
import {DateTime} from 'luxon'

import getServerDateOffset from './getServerDateOffset'
import Clock from './Clock'
import useFullScreenFeature from '../../../../hooks/useFullScreenFeature'
import {useAppCtx} from '../../../../contexts/appCtx'
import useComponentSize from '../../../../hooks/useComponentSize'


export default function OnlineClock() {
  const [offset, setOffset] = React.useState(0)
  React.useEffect(() => {
    getServerDateOffset()
      .then(offset => setOffset(offset))
  }, [])

  const [date, setDate] = React.useState(null)
  React.useEffect(() => {
    const interval = setInterval(() => {
      setDate(new Date(new Date().getTime() + offset))
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [offset])

  const ref = React.useRef()
  const {width, height, ready} = useComponentSize(ref)

  const [size, setSize] = React.useState(480)
  React.useEffect(() => {
    if (ready) {
      const size = Math.min(width, height)
      setSize(size)
    }
  }, [width, height, ready])

  const appCtx = useAppCtx()
  const [ResultFullScreenButton, ResultFullScreenContainer] = useFullScreenFeature()

  return (
    <Paper css={css`
      margin: 0 auto;
      max-width: 600px;
      height: 100%;

      position: relative;
      padding: 36px;
    `}>
      {!appCtx.isMobile && <div css={css`
        position: absolute;
        top: 0;
        right: 16px;
      `}>
        <ResultFullScreenButton/>
      </div>}
      <ResultFullScreenContainer>
        <div css={css`
          width: 100%;
          height: 100%;

          display: flex;
          flex-direction: column;
          align-items: center;
        `}>
          <div
            ref={ref}
            css={css`
              flex: 3;
              width: 100%;
              padding: 8px;
              display: flex;
              align-items: center;
              justify-content: center;
            `}
          >
            {date && <Clock size={size} date={date} renderNumbers/>}
          </div>

          {/*<div css={css`*/}
          {/*  flex: 1;*/}
          {/*`}>*/}
          {/*  {date && (*/}
          {/*    <Moment*/}
          {/*      css={css`*/}
          {/*        font-size: ${Math.floor(size) / 5}px;*/}
          {/*        font-weight: 800;*/}
          {/*      `}*/}
          {/*      date={date}*/}
          {/*      element={'time'}*/}
          {/*      format={'HH:mm:ss'}/>*/}
          {/*  )}*/}
          {/*</div>*/}

          <div css={css`
            flex: 1;
          `}>
            {date && (
              <time
                css={css`
                  font-size: ${Math.floor(size) / 5}px;
                  font-weight: 800;
                `}>
                {DateTime.fromJSDate(date).toLocaleString(DateTime.TIME_24_WITH_SECONDS)}
              </time>
            )}
          </div>
        </div>
      </ResultFullScreenContainer>
    </Paper>
  )
}



